<template>
  <router-view/>
</template>

<style lang="scss">
html,body {
  margin: 0;
  height: 100%;
  font-family: var(--font-body) !important;
  font-weight: 200;
  font-size: 16px;
  color: var(--color-darky) !important;
}

#app {
  width: 100%;
  max-width: 100%;
  height: 100%;
  font-size: 1.25rem;
}

h1 {
  font-family: var(--font-display);
  font-style: var(--font-display-style);
  font-weight: var(--font-display-weight);
  font-size: 4.125rem !important;
  line-height: 4rem !important;
  letter-spacing: 0.125rem;
  margin: 0;
  padding: 0;
}

h2 {
  font-weight: 400 !important;
  font-size: 1.375rem !important;
  margin: 0;
  padding: 0;
}

.bg-sady {
  background-color: var(--color-sady);
}

.bg-greeny {
  background-color: var(--color-greeny);
}

.bg-warny {
  background-color: var(--color-warny);
}

.bg-darky {
  background-color: var(--color-darky);
}

a {
  text-decoration: none !important;
  border: 0 !important;
  outline: 0 !important;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  color: var(--color-darky);
  border: 1px solid var(--color-darky);
  outline: none !important;
  padding: 1rem 3.75rem;
  width: 100%;
  min-width: 100%;
  border-radius: 0.125rem !important;
  -moz-border-radius: 0.125rem !important;
  font-weight: 200;

  &[disabled] {
    background-color: rgba(192,123,118, 0.7) !important;
    color: #bd3037 !important;
    cursor: not-allowed;
    &:hover,
    &:focus,
    &:focus-visible,
    &:focus-within,
    &:active {
      background-color: rgba(192,123,118, 0.7) !important;
    }
  }

  &.button-primary {
    background-color: var(--color-darky);
    color: var(--color-sady);
    &:hover,
    &:focus,
    &:focus-visible,
    &:focus-within {
      background-color: var(--color-darky-hover);
    }
    &:active {
      background-color: var(--color-darky-active);
    }
  }

  &.button-warn {
    background-color: var(--color-warny);
    color: var(--color-sady);
    border: none;
    &:hover,
    &:focus,
    &:focus-visible,
    &:focus-within {
      background-color: var(--color-warny-hover);
    }

    &:active {
      background-color: var(--color-warny-active);
    }
  }

  &.button-greeny {
    background-color: var(--color-greeny);
    color: var(--color-darky) !important;
    border: 1px solid var(--color-darky);
    &:hover,
    &:focus,
    &:focus-visible,
    &:focus-within {
      background-color: var(--color-greeny-hover);
      border: 1px solid var(--color-darky);
    }
    &:active {
      background-color: var(--color-greeny-active);
    }
  }

  &.button-trans {
    background-color: rgba(225,225,225,0.5);
    color: var(--color-sady);
    border: 1px solid var(--color-sady);
    &:hover,
    &:focus,
    &:focus-visible,
    &:focus-within,
    &:active {
      background-color: rgba(225,225,225,0.5);
    }
  }

  &:hover,
  &:focus,
  &:focus-visible,
  &:focus-within,
  &:active {
    background-color: rgba(220,220,220, 0.7);
  }

  &.round {
    padding: unset !important;
    width: 4rem;
    min-width: 4rem;
    height: 4rem;
    min-height: 4rem;
    border-radius: 2rem !important;
    -moz-border-radius: 2rem !important;
    font-size: 1.5rem;
    font-weight: 500;
  }
}
</style>
